import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['form']

  async submit(event) {
    event.preventDefault()

    const form = this.formTarget
    const { url } = form.dataset
    const formData = new FormData(form)

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: formData
      })

      const text = await response.text()
      let data

      try {
        data = JSON.parse(text)
      } catch {
        data = null
      }

      if (data && data.toastr && window.toastr) {
        const { type = 'info', message, title } = data.toastr
        const fn = window.toastr[type] || window.toastr.info
        if (fn) fn(message, title)
      }

      if (response.ok) {
        document.dispatchEvent(new Event('modal:close'))
      } else if (!data?.toastr && window.toastr) {
        window.toastr.error(`Request failed (status: ${response.status})${text ? `: ${text}` : ''}`)
      }
    } catch (error) {
      if (window.toastr) window.toastr.error(`Network error: ${error.message}`)
    }
  }
}
